import React from 'react';

const CaseCategoriesListEmpty = () => {
  return <div></div>;
};

export default CaseCategoriesListEmpty;
